import React, { Fragment } from 'react';
import styles from '../Dashboards.module.css';
import MultiPanel from '../../common/MultiPanel';
import ExtensionList from './ExtensionList';
import ReportInfo from './ReportInfo';

function ReportPicker({
  selectedReport,
  setSelectedReport,
  selectedReportType,
  setSelectedReportType,
  context,
}) {
  return (
    <Fragment>
      <div className={styles.ModalBodyTitle}>Select panel</div>
      <div className={styles.ModalBodyContent}>
        <MultiPanel>
          <ExtensionList
            selectedReportType={selectedReportType}
            selectedReport={selectedReport}
            setSelectedReport={setSelectedReport}
            context={context}
          />
          <ReportInfo selectedReport={selectedReport} />
        </MultiPanel>
      </div>
    </Fragment>
  );
}

export default ReportPicker;
